export const HOSTNAME = process.env.REACT_APP_HOSTNAME as string;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT as string;
export const API_VERSION = process.env.REACT_APP_API_VERSION as string;
export const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_API_ID as string;
export const GOOGLE_WEB_CLIENT_ID = process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID as string;
export const DIBSY_PUBLIC_KEY_LIVE = process.env.REACT_APP_DIBSY_PUBLIC_KEY_LIVE as string;
export const DIBSY_PUBLIC_KEY_TEST = process.env.REACT_APP_DIBSY_PUBLIC_KEY_TEST as string;
export const MAPBOX_PUBLIC_API_KEY = process.env.REACT_APP_MAPBOX_PUBLIC_API_KEY as string;
